import { createContext, Context } from 'react';

const RelatedPathContext: Context<any> = createContext(null);

export default RelatedPathContext;
